const en = {
    Customers: {
        name: "Customer Name",
        namePlaceholder: "Enter Customer Name",
        countryLabel: "Select Customer Country",
        countryPlaceholder: "Select Customer Country",
        identityLabel: "Tax ID / Identity Number",
        identityPlaceholder: "Enter Tax ID / Identity Number",
        taxLabel: "Tax Office",
        taxPlaceholder: "Enter Tax Office",
    },
    Competitors: {
        companyLabel: "Competitor Company Name",
        companyPlaceholder: "Enter Competitor Company",
    },
    Errors: {
        required: "required field.",
    },
};

export default en;
